"use strict";

angular.module("informaApp")
    .service("CompanyModesEnum", function () {
        return {
            all: 0,
            partnersOnly: 1,
            leadOnly: 2
        }
    });